/** Versão única dos termos aceitos pela Assinatura Simples no 6D-2. */
export const CONSENT_TERMS_VERSION = 'argink-consent-terms/v1' as const;
